import { gql } from '@apollo/client';

const GET_APPLE_TV = gql`
    query getAppleTV($SerialNumber: String, $UDID: String) {
        configProfiles {
            PayloadDisplayName
            PayloadDescription
            PayloadOrganization
            PayloadIdentifier
            PayloadUUID
            MobileConfigData
        }
        appletv(SerialNumber: $SerialNumber, UDID: $UDID) {
            SerialNumber
            ProductName
            OSVersion
            UDID
            mdmProfileInstalled
            hasBootstrapToken
            assetTag
            assignedDirectoryUser {
                _id
                name
                firstName
                lastName
                username
                role
                className
                classes
                managedAppleId
                asmUserId
            }
            location {
                _id
                name
                schoolNumber
            }
            QueryResponses {
                AvailableDeviceCapacity
                BluetoothMAC
                DeviceID
                BuildVersion
                DeviceCapacity
                DeviceName
                IsSupervised
                Model
                ModelName
                ModelNumber
                OSVersion
                ProductName
                SerialNumber
                SoftwareUpdateDeviceID
                TimeZone
                UDID
                WiFiMAC
            }
            Applications {
              Identifier
              Name
              Version
            }
            disabledProfiles {
                PayloadIdentifier
                PayloadDisplayName
                disabledAt
            }
            assignedSettingsProfiles {
                profileId
                PayloadDisplayName
                PayloadIdentifier
                PayloadUUID
                PayloadDescription
                PayloadOrganization
                PayloadType
                kind
                source
                groupName
                hasInstallablePayload
            }
            assignedDeviceGroups {
                groupId
                groupName
            }
            enrollmentContext {
                hasDepAssignment
                depProfileUuid
                depProfileName
                depIsSupervised
            }
            Profiles {
                HasRemovalPasscode
                IsEncrypted
                IsManaged
                PayloadDescription
                PayloadDisplayName
                PayloadIdentifier
                PayloadOrganization
                PayloadType
                PayloadUUID
                PayloadVersion
                PayloadRemovalDisallowed
                PayloadContent {
                    PayloadDescription
                    PayloadDisplayName
                    PayloadIdentifier
                    PayloadOrganization
                    PayloadType
                    PayloadUUID
                    PayloadVersion
                }
              }
            CertificateList {
                CommonName
                IsIdentity
            }
            AvailableSoftwareUpdates {
                AllowsInstallLater
                Build
                DownloadSize
                InstallSize
                HumanReadableName
                HumanReadableNameLocale
                IsConfigDataUpdate
                IsCritical
                IsFirmwareUpdate
                IsSecurityResponse
                ProductKey
                ProductName
                RequiresBootstrapToken
                RestartRequired
                SupplementalBuildVersion
                Version
            }
            OSUpdateStatus {
                ProductKey
                Status
                DownloadPercentComplete
                IsDownloaded
            }
            OSUpdateResults {
                InstallAction
                ProductKey
                Status
                ErrorChain {
                    ErrorCode
                    ErrorDomain
                    LocalizedDescription
                    USEnglishDescription
                }
            }
            lastCheckedIn
            lastDdmStatusReportAt
            updatedAt
        }
    }
`

export { GET_APPLE_TV };
